import classNames from 'classnames'
import { motion } from 'framer-motion'
import { type CSSProperties, type FC } from 'react'
import styles from './ToggleButton.module.scss'

interface ToggleSwitchProps {
  checked: boolean;
  setChecked: (checked: boolean) => void;
  uncheckedText?: string;
  checkedText?: string;
  width?: string;
  id?: string;
}

export const ToggleButton: FC<ToggleSwitchProps> = ({
  checked,
  setChecked,
  uncheckedText = 'Off',
  checkedText = 'On',
  width = '7rem',
  id = '1'
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setChecked(event.target.checked)
  }

  const checkboxId = `checkbox_${id}`

  return (
    <div
      className={styles.container}
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      style={{
        '--toggle-width': width
      } as CSSProperties}
    >
      <label aria-label="Toggle" htmlFor={checkboxId} className={styles.switch}>
        <input
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          name={checkboxId}
          id={checkboxId}
        />
        <span className={classNames(styles.slider, styles.round)} />
      </label>
      {!checked && (
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: checked ? 0 : 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7 }}
          className={classNames(styles.text, {
            [styles.checked]: checked
          })}
        >
          {uncheckedText}
        </motion.span>
      )}
      {checked && (
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: checked ? 1 : 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7 }}
          className={classNames(styles.text, {
            [styles.checked]: checked
          })}
        >
          {checkedText}
        </motion.span>
      )}
    </div>
  )
}
